import styled, { css } from 'styled-components';
import Text from 'shared/components/Text/Text';

export const ReviewAgreementContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 488px;
`;

export const Title = styled(Text)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
  margin-bottom: 12px;

  @media (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    align-self: center;
    margin-bottom: 24px;
  }
`;

export const BodyTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const BodyText = styled(Text)`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
`;

export const VideoPlayerWrapper = styled.div`
  align-self: center;
  border: 1px solid ${({ theme }) => theme.colors.strokeSecondaryGrey10};
  border-radius: 8px;
  margin: 12px 0 20px;

  @media (min-width: ${({ theme }) => theme.breakpoints.small}) {
    margin: 32px 0;
    border-radius: 20px;
    box-shadow: ${({ theme }) => theme.elevations.highest};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    margin: 24px 0 32px;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  width: 100%;
  gap: 12px;

  @media (min-width: ${({ theme }) => theme.breakpoints.small}) {
    width: 256px;
  }
`;

export const TextDivider = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    text-align: center;
    margin-top: 24px;
    margin-bottom: 24px;

    &::before,
    &::after {
      content: '';
      flex: 1;
      border-bottom: 1px solid ${theme.colors.backgroundInteractionActiveGrey20};
      margin: 0 8px;
    }
  `}
`;
